import React from "react";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Container from "@material-ui/core/Container";
import Fab from "@material-ui/core/Fab";
import MenuIcon from "@material-ui/icons/Menu";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import ScrollToTop from "./scrollToTop";
import Paper from "@material-ui/core/Paper";
import Card from "@material-ui/core/Card";
import Divider from "@material-ui/core/Divider";
import ContactsIcon from '@material-ui/icons/Contacts';
import { NavLink } from "react-router-dom";
import { useTheme } from "@material-ui/core/styles";
import EntityMenu from "../components/EntityMenu";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import * as portalStyle from "./portalStyle";
import * as authHelpers from "../authentication/authHelpers";
import * as routeHelpers from "../authentication/routeHelpers";
import * as settings from "../shared/settingsConstants"
import { useHistory } from "react-router-dom";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators as authActions } from '../redux/actions/authActions';

function MainOutlet(props) {
  const { container } = props;
  const classes = portalStyle.useStyles();
  const theme = useTheme();
  const history = useHistory();
  const [logout, setLogout] = React.useState(false);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [errorMessage, setErrorMessage] = React.useState('');
  const open = Boolean(anchorEl);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

    const handleLogout = (dispatch) => {
        console.log(props);
      props
      .signOut()
      .then(() => {
        setLogout(true);
      })
      .catch((error) => {
        setErrorMessage(
          error?.errorMessage ? error?.errorMessage : 'The code entered was invalid, please try again.'
        );
      });
  };

  // const handleRevoke = () => {
  //   handleClose();
  //   history.push(routeHelpers.buildRoute("/revoke-account"));
  // }

  const drawerMenu = (
    <div>
      <Toolbar className={classes.logoBar}>
        <div className={classes.logoContainer}>
          <NavLink to={routeHelpers.buildRoute("")}>
            <img src={theme.palette.custom ? theme.palette.custom.logoSrc : settings.portalSettings.logoSrc} className={classes.logo} alt="logo" />
          </NavLink>
        </div>
      </Toolbar>
      <List className={classes.entityMenuList}>
        <Card className={classes.entityMenuCard} square>
          <ListItem>
            <ListItemIcon className={classes.drawerIcon}>
              <ContactsIcon />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography
                  variant="subtitle1"
                  className={classes.drawerListHeader}
                >
                  Profiles
                </Typography>
              }
            />
          </ListItem>
          <Divider light />
          <div className={classes.entityMenu}>
            <EntityMenu />
          </div>
        </Card>
      </List>
      <div className={classes.drawerStamp}>
              &copy; <a href="https://www.inscope-aml.com" className="main-copyright-link copyright-link">InScope-AML</a> - Self-Service Portal
      </div>
    </div>
  );

  if (logout) {
    return authHelpers.logout();
  }

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar className={classes.toolBar}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap className={classes.title}>
            <div className={classes.appLogoContainer}>
              <NavLink to="/">
                <img src={theme.palette.custom ? theme.palette.custom.logoSrc : settings.portalSettings.logoSrc} className={classes.logo} alt="logo" />
              </NavLink>
            </div>
          </Typography>
          <div>
            <span className={classes.authName}>
              {authHelpers.getAuthUserName()}
            </span>
            <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <AccountCircleIcon className={classes.toolbarIcon} />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={open}
              onClose={handleClose}
            >
              <MenuItem onClick={handleLogout}>
                <ExitToAppIcon style={{ marginRight: 5 }} />
                Logout
              </MenuItem>
              {/* <MenuItem onClick={handleRevoke}>
                <ExitToAppIcon style={{ marginRight: 5 }} />
                Revoke Account
              </MenuItem> */}
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
      <nav className={classes.drawer} aria-label="mailbox folders">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === "rtl" ? "right" : "left"}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawerMenu}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawerMenu}
          </Drawer>
        </Hidden>
      </nav>
      <main className={classes.content}>
        <Toolbar id="back-to-top-anchor" variant="dense" />
        <Container className={classes.outerContainer}>
          <Container maxWidth="lg" className={classes.innerContainer}>
            <Paper className={classes.containerPaper} elevation={2}>
              <Container maxWidth="md" className={classes.contentContainer}>
                {props.rootOutlet}
              </Container>
            </Paper>
          </Container>
        </Container>
        <ScrollToTop {...props}>
          <Fab color="secondary" size="small" aria-label="scroll back to top">
            <KeyboardArrowUpIcon />
          </Fab>
        </ScrollToTop>
      </main>
    </div>
  );
}

export default connect(
    null, (dispatch) => bindActionCreators(authActions, dispatch)
)(MainOutlet);

//export default MainOutlet;
